import { useContext } from "react";
import Context from "../../../context";

export default function ModalButton({
  className,
  modal,
  payload,
  children,
  icon,
}) {
  const { contextState, setContextState } = useContext(Context);

  const data = {
    type: [modal],
    payload: [payload],
  };

  return (
    <button
      className={className}
      onClick={() => setContextState({ ...contextState, modal: data })}>
      {icon && icon}
      <p className="btn-text">{children}</p>
    </button>
  );
}
